/** Where a zone map opens with nothing to show yet: Nairobi, the centre of Index Cargo's corridor (#21), zoomed out to the region. */
export const CORRIDOR_CENTER: [number, number] = [36.8219, -1.2921];
export const CORRIDOR_ZOOM = 6;

/** Framing a zone or a set of zones. The zoom cap keeps a named point (zero-size bounds) or a tiny gate at street level rather than the tile limit. */
export const ZONE_FIT_OPTIONS = { padding: 48, maxZoom: 16 };
